import axios, {AxiosResponse} from "axios";


const API_URL = process.env.REACT_APP_API_URL
const GLOBAL_API_URL = `${API_URL}global`

export const REQUEST_SETTING_URL = `${GLOBAL_API_URL}/GetSetting`
export const REQUEST_LANGUAGES_URL = `${GLOBAL_API_URL}/ListLanguages`
export const REQUEST_CHANGE_LANGUAGE_URL = `${GLOBAL_API_URL}/ChangeLang`

export async function getSetting(settingCode: string):Promise<any>
{
    return  axios.get(
        REQUEST_SETTING_URL,
        {
            params: {
                Code: settingCode
            }
        }
    )
}
export async function getListLanguages():Promise<AxiosResponse<any>>
{
    return  axios.get(
        REQUEST_LANGUAGES_URL
    )
}
export async function changeLanguage(languageCode: string):Promise<any>
{
    return  axios.get(
        REQUEST_CHANGE_LANGUAGE_URL,
        {
            params: {
                Lang: languageCode
            }
        }
    )
}